import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { fetchBankWallets } from '@app/store/slices/bankWalletsSlice';
import { roles } from '@shared/static/roles';
import { theme } from '@utils/libs/theme';
import Sidebar, { drawerWidth } from '@widgets/sidebar/Sidebar';
import { SidebarBottom } from '@widgets/sidebar/parts';

const hideSidebarUrls = ['/profile'];

export default function Layout() {
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isHideSidebar = hideSidebarUrls.includes(location.pathname);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    // if (user?.group_role !== roles.TEAM_MEMBER) {
    dispatch(fetchBankWallets());
    // }
  }, [dispatch]); //user?.group_role

  return (
    <Box sx={{ display: { xs: 'block', md: 'flex' } }} className="main-layout">
      {isMobile ? !isHideSidebar && <SidebarBottom /> : <Sidebar />}
      <Box
        component="main"
        sx={{
          width: { md: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
